import { apiInterfaceForJson } from "../common/apiManager";

export const getAssignmentHistory = (leadId, limit = 50) => {
    const params = limit ? `?limit=${limit}` : "";
    return apiInterfaceForJson(`/assignmentLog/v1/history/${leadId}${params}`, "GET");
};

